import utils from "../../../src/js/utils";

var timeline = {
	el: document.querySelector(".timeline-block .splide"),
	set: {
		height: function () {
			var pHeight = timeline.el.querySelectorAll(".content p:last-of-type");
			utils.forEach(pHeight, function (index, el) {
				if (el.scrollHeight > el.offsetHeight) {
					el.parentElement.parentElement.style.display = "flex";
					el.parentElement.parentElement.style.alignItems = "center";
					el.parentElement.style.height = "auto";
					el.style.height = "auto";
				}
			});
		},
		slider: function () {
			var splide = new Splide(timeline.el, {
				lazyLoad: "sequential",
				speed: 1000,
				pagination: false,
				arrows: false,
				easing: "ease",
				autoScroll: false,
				intersection: false,
				autoplay: true,
				interval: 3000,
				autoWidth: true,
				mediaQuery: "min",
				breakpoints: {
					1024: {
						autoplay: false,
						autoScroll: {
							speed: 2,
							autoStart: false,
							pauseOnHover: true,
						},
						intersection: {
							inView: {
								autoScroll: true,
							},
							outView: {
								autoScroll: false,
							},
						},
					},
				},
				i18n: {
					slideLabel: "%s di %s",
				},
			});

			//splide.on('mounted', function () {});

			splide.on("mounted", function () {
				var list = timeline.el.querySelector(".splide__list");
				list.style.setProperty("--width", list.scrollWidth + "px");
			});

			window.splide ? splide.mount(window.splide.Extensions) : splide.mount();
		},
		cursor: function () {
			timeline.el.addEventListener("mouseenter", function (e) {
				cursor.enter("grab");
			});

			timeline.el.addEventListener("mouseleave", function () {
				cursor.leave("grab");
			});
		},
	},
	init: function () {
		if (timeline.el) {
			if (utils.screen.width > 767) {
				timeline.set.height();
			}
			timeline.set.slider();
			timeline.set.cursor();
		}
	},
};

utils.domReady(function () {
	timeline.init();
});
